module Meevo.Plugins.Client {

    import IClientPackage = Meevo.Model.IClientPackage;
    import IClientPackageService = Meevo.Model.IClientPackageService;
    import IClientPackageTransaction = Meevo.Model.IClientPackageTransaction;
    import SalesTypeEnum = Meevo.Model.SalesTypeEnum;

    enum PackageType {
        All,
        Active,
        Expirednobalance,
        SplitMerge
    }

    interface IPackageCriteria {
        client_TId: Guid;
        isExpired?: boolean;
        isRemaining?: boolean;
        isSplitMerged?: boolean;
        isExpiredOrRemaining?: boolean;
        isGlobal: boolean
    }

    interface IPackageRequest {
        criteria: IPackageCriteria;
        pageNumber: number;
        itemsPerPage: number;
    }

    export class PackagesSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.Client> {
        public packagesFilter: PackageType = PackageType.All;
        private _packagesList: Array<IClientPackage> = [];
        private _isGlobal: boolean;

        public packageTypeList = [
            {value: PackageType.All, label: 'LABEL_SHOW_ALL'},
            {value: PackageType.Active, label: 'LABEL_ACTIVE'},
            {value: PackageType.Expirednobalance, label: 'LABEL_EXPIRED_NO_BALANCE' },
            {value: PackageType.SplitMerge, label: 'HEADER_SPLIT_MERGE' }
        ];

        get isGlobal(): boolean {
          return this._isGlobal;
        }
        set isGlobal(value: boolean) {
          this._isGlobal = value;
        }

        get packagesList(): Array<IClientPackage>{
            return this._packagesList;
        }
        /**
         * Updating packages list with formatted dates and packages transactions
         * */
        set packagesList(list: Array<IClientPackage>){
            let resolve: Array<angular.IPromise<any>> = [],
                criteria: Object = {pageNumber: 0, ItemsPerPage: 1000, isGlobal: this.isGlobal};

            list.forEach((item: IClientPackage) => {
                resolve.push(this.dataService.getListPaged(`ClientPackage/${item.clientPackage_TId}/Transaction`, criteria));
            });

            this.$q.all(resolve)
                .then((values: Array<any>) => {
                    values.forEach((item: Array<IClientPackageTransaction>, i: number) => {
                        this.packagesList[i].transactions = item;
                    });
                });

            this._packagesList = list;
        }

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            protected identityService: Meevo.Components.Common.IIdentityService = null,
            noun: Meevo.Model.NounEnum = null,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $q: angular.IQService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected $rootScope: angular.IRootScopeService,
            sectionSecurityKey?:string
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService,identityService,noun,appSettings,sectionSecurityKey);
            this.noun = noun;
        }

        /**
         * Updating packages on tab selected
         * */
        public selected(): void {
            this.getPackages();
        }

        /**
         * Getting packages from database according to selected filter
         * */
        public getPackages(): void{
            let data: IPackageRequest = {
                criteria: {
                  client_TId: this.parentItemId,
                  isGlobal: this.isGlobal
                },
                pageNumber: 0,
                itemsPerPage: 1000
            };

            this.busyService.start();

            switch (this.packagesFilter){
                case PackageType.Active:
                    data.criteria.isExpired = false;
                    data.criteria.isRemaining = true;
                    data.criteria.isExpiredOrRemaining = false;
                    break;
                case PackageType.Expirednobalance:
                    data.criteria.isExpired = true;
                    data.criteria.isRemaining = false;
                    data.criteria.isExpiredOrRemaining = true;
                    break;
                case PackageType.SplitMerge:
                    data.criteria.isSplitMerged = true;
                    break;
            }

            this.dataService.getListPaged(this.appSettings.API_ENDPOINTS.clientPackageHistory, data)
                .then((data: any) => {
                    this.packagesList = data;
                    this.packagesList.forEach((clientPackage) =>
                        clientPackage.clientPackageItems = [...clientPackage.clientPackageServices, ...clientPackage.clientPackageProducts]);
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }

        /**
         * get string enum value
         * @param {SalesTypeEnum} value
         * @returns {string}
         */
        getSalesType(value: SalesTypeEnum): string {
            return SalesTypeEnum[value];
        }

        /**
        * Open selected transaction in Transaction Editor
        * @param {string} transactionNumber
        */
        openTransactionEditor(transactionNumber: string): void {
            if (!transactionNumber) return;

            // Build params for loading transaction in editor
            let stateParams = {
                transactionId: transactionNumber,
                includeActive: true,
                includeCompleted: true,
                includeOnHold: false,
                includeRefunded: true,
                includeVoided: true
            };

            this.$rootScope.$broadcast("gotoState", {
                stateName: this.appSettings.ROUTE_NAMES.transactionEditor,
                stateParams: stateParams,
                securityKey: Meevo.Components.Common.SecurityKeys.REGISTER_TRANSACTIONEDITOR + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
            });
        }

        packageHasServices(clientPackage): boolean {
            return (clientPackage.clientPackageServices.length + clientPackage.clientPackageUnlimitedServices.length) > 0;
        }
    }
}